import React from 'react';
import LeadsData from '../../LeadsData';
import SectionLayout from '../../SectionLayout';
import Charts from '../../Charts';
import { Container, LeadsWrapper } from './styles';
import ImpressionsIcon from '../../../assets/icons/impressionsIcon.svg';
import VisitsIcon from '../../../assets/icons/visitsIcon.svg';
import LeadsIcon from '../../../assets/icons/leadsIcon.svg';

const GeneralData = ({
  data = {},
  dataCharts,
  chartType,
  setChartType,
  device,
  filter,
  startFilter,
  endFilter,
  isStatisticsByPosting,
  postingId,
  leadsChartsError,
  reloadDispatch
}) => {
  const { impressions = {}, visits = {}, leads = {} } = data;
  const isDesktop = device === 'desktop';

  return (
    <SectionLayout marginTop={!isDesktop && 0} padding={!isDesktop && 16}>
      <Container>
        <LeadsWrapper
          isDesktop={isDesktop}
          data-panel='panel-estadisticas-generalData-container'
          data-tour-panel='estadisticas-metrics'
        >
          <LeadsData
            icon={ImpressionsIcon}
            id='impressions'
            principalValue={impressions.total || '0'}
            difference={impressions.percentage || '0'}
            score={impressions.status || 'EQUAL'}
            device={device}
            isStatisticsByPosting={isStatisticsByPosting}
            filter={filter}
          />
          <div className='separator' />
          <LeadsData
            icon={VisitsIcon}
            id='visits'
            principalValue={visits.total || '0'}
            difference={visits.percentage || '0'}
            score={visits.status || 'EQUAL'}
            device={device}
            isStatisticsByPosting={isStatisticsByPosting}
            filter={filter}
          />
          <div className='separator' />
          <LeadsData
            icon={LeadsIcon}
            id='leads'
            principalValue={leads.total || '0'}
            secundaryValue={leads.totalLeads || '0'}
            tertiaryValue={leads.anonymousLeads || '0'}
            difference={leads.percentage || '0'}
            differenceTotal={leads.totalPercentage || '0'}
            differenceTertiary={leads.anonymousPercentage || '0'}
            score={leads.status || 'EQUAL'}
            scoreTotal={leads.totalStatus || 'EQUAL'}
            scoreTertiary={leads.anonymousStatus || 'EQUAL'}
            device={device}
            isStatisticsByPosting={isStatisticsByPosting}
            filter={filter}
          />
        </LeadsWrapper>
        {isDesktop && (
          <Charts
            chartType={chartType}
            setChartType={setChartType}
            dataCharts={dataCharts || ''}
            filter={filter}
            startFilter={startFilter}
            endFilter={endFilter}
            device={device}
            isStatisticsByPosting={isStatisticsByPosting}
            postingId={postingId}
            error={leadsChartsError}
            reloadDispatch={reloadDispatch}
          />
        )}
      </Container>
    </SectionLayout>
  );
};

export default GeneralData;
